<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Multiselect from 'vue-multiselect';
import Swal from "sweetalert2";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Multiselect, Swal },
    data() {
        return {
            title: "Crear Evento",
            items: [
                {
                text: "Eventos",
                href: "/"
                },
                {
                text: "Crear Evento",
                active: true
                }
            ],
            colegio:{},
            evento:{
                asunto:'',
                codigo:'',
                area:'Difusión',
                propietario:[],
                curso:[],
                tipo:'',
                subtipo:'',
                coordinador_evento:[],
                colegio:''
            },
            bloquearColegio:false,
            tipos:[],
            subtipos:[],
            subtiposfilter:[],
            cursos: ['Primero Medio', 'Segundo Medio', 'Tercero Medio', 'Cuarto Medio', 'Egresado'],
            emailError:'',
            phoneerror:'',
            usuarios:[],
            colegios:[],
            isLoading:false,
            selected:'Mis colegios',
            todos_colegios:[]
        };
    },
    computed:{
        isEmailValid() {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(this.evento.email);
        }
    },
    methods:{
        validateEmail() {
            if (this.evento.email && !this.isEmailValid) {
                this.emailError = 'El correo electrónico no es válido.';
            } else {
                this.emailError = '';
            }
        },
        formatPhoneNumber() {
            // Elimina todo lo que no sea número
            let digits = this.evento.telefono.replace(/\D/g, "");

            // Agrega el prefijo "+56" si no está presente
            if (!digits.startsWith("56")) {
                digits = "56" + digits;
            }

            // Limita a un máximo de 11 caracteres (+56 + 9 dígitos)
            if (digits.length > 11) {
                digits = digits.slice(0, 11);
            }

            // Actualiza el input con el formato correcto
            this.evento.telefono = "+" + digits;
        },
        validatePhoneNumber() {
            // Validar que el número tenga exactamente 11 caracteres (+56 + 9 dígitos)
            if (this.evento.telefono.length !== 12) {
                this.phoneerror = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror = "";
                //alert("Número válido: " + this.datos.telefono);
                // Aquí puedes continuar con el envío del formulario
            }
        },
        restrictToNumbers(event) {
            const allowedKeys = [
                "Backspace",
                "Tab",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
            ];
            // Permitir teclas especiales y números
            if (
                !allowedKeys.includes(event.key) &&
                !/^\d$/.test(event.key) // Permitir solo números
            ) {
                event.preventDefault();
            }
        },
        msg(tipo,titulo){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                //text: '',
                showConfirmButton: false,
                timer: 5000
            });
        },
        msgval(campo) {
            Swal.fire({
                icon: 'error',
                title: 'Campo Obligatorio',
                text: `Por favor, completa el campo "${campo}".`,
                confirmButtonText: 'Aceptar'
            });
        },
        validacion() {
            const campos = {
                //correo_colegio_2: 'Correo Orientador',
                nombre_difusion: 'Nombre',
                fecha_inicio: 'Fecha Inicio',
                fecha_termino: 'Fecha Término',
                tipo: 'Tipo',
                subtipo: 'Subtipo',
                curso: 'Curso',
                email: 'Correo Electrónico',
                telefono: 'Teléfono',
                titulo_landing_inscripcion: 'Difusión digital',
                coordinador_evento: 'Coordinador Evento',
                rbd: 'RBD',
                colegio: 'Colegio',
            };
            // if(this.evento.colegio.rbd=='0000000'){
            //     this.evento.correo_colegio_2=this.evento.email
            // }else{
            //     this.evento.correo_colegio_2=this.evento.colegio.correo_colegio_2
            // }
            for (let campo in campos) {
                if (!this.evento[campo]) {
                    this.msgval(campos[campo]);
                    return;
                }
            }
            this.crear_evento();
        },
        ver_evento(evento){
            localStorage.setItem('evento_codigo',evento);
            window.location.href = "/web/configuracion/eventos";
        },
        crear_evento() {
            this.isLoading = true;
            this.enviar_evento();
            /*axios.post('/api/validar_evento_solapado', {
                fecha_inicio: this.evento.fecha_inicio,
                fecha_termino: this.evento.fecha_termino,
                coordinador_evento: this.evento.coordinador_evento.id,
                rbd_colegio: this.evento.colegio.rbd,
                tipo_id: this.evento.tipo.id
            }).then(res => {
                if (!res.data.solapado) {
                    this.msg('error', 'Ya existe evento, colegio y tipo en el mismo horario.');
                    this.isLoading = false;
                } else {
                    this.enviar_evento(); // Si no hay solape, continuar
                }
            }).catch(error => {
                console.error(error);
                this.isLoading = false;
            });*/
        },
        enviar_evento(){
            let formData = new FormData();
            formData.append('nombre_difusion', this.evento.nombre_difusion);
            formData.append('fecha_inicio', this.evento.fecha_inicio);
            formData.append('fecha_termino', this.evento.fecha_termino);
            formData.append('tipo', this.evento.tipo.codigo);
            formData.append('subtipo', this.evento.subtipo.codigo);
            formData.append('propietario', this.evento.propietario.name);
            formData.append('curso', JSON.stringify(this.evento.curso));
            formData.append('email', this.evento.email);
            formData.append('telefono', this.evento.telefono);
            formData.append('titulo_landing_inscripcion', this.evento.titulo_landing_inscripcion);
            formData.append('user_id', this.evento.coordinador_evento.id);
            formData.append('coordinador_evento', this.evento.coordinador_evento.rut);
            formData.append('user_id', this.evento.coordinador_evento.id);
            formData.append('coordinador', this.evento.coordinador_evento.name);
            formData.append('rbd', this.evento.colegio.rbd);
            formData.append('colegio', this.evento.colegio.nombre);
            formData.append('sede_asociada', this.evento.propietario.sede);
            //formData.append('correo_colegio_2', this.evento.correo_colegio_2);
            axios.post('/api/crear_evento',formData).then(res=>{
                if(res.data.estado){
                    this.msg(res.data.color,res.data.mensaje);
                    setTimeout(() => {
                        this.ver_evento(res.data.codigo)
                    }, 3000);
                }else{
                    this.msg(res.data.color,res.data.mensaje);
                }
            })
            .catch(error => console.error(error))
            .finally(() => this.isLoading = false);
        },
        ver_subtipo(){            
            this.subtiposfilter = this.subtipos.filter((subtipo) => subtipo.tipo_id==this.evento.tipo.id);
        },
        labelselect_tipo ({ nombre }) {
            return `${nombre}`
        },
        labelselect_usuarios ({ name }) {
            return `${name}`
        },
        labelselect_colegio ({ nombre , rbd}) {
            return `${rbd}-${nombre}`
        },
        cambio_colegios(){
            if (this.selected=='Todos') {
                this.colegios = this.todos_colegios;
            }else if(this.selected=='Mis colegios'){
                this.colegios = this.todos_colegios.filter((colegio) => colegio.user_id==this.user.id);
            }
            console.log(this.colegios);
        }
    },
    mounted(){
        axios.get('/api/get_tipos').then(res=>{
            this.tipos=res.data.tipos.filter(t=>t.codigo)
            this.subtipos=res.data.subtipos
            //this.subtiposfilter=res.data.subtipos
            //console.log(this.tipos);
            
        });
        
    },
    created(){
        if (localStorage.getItem("colegio")) {
            const colegio = localStorage.getItem("colegio");
            this.colegio=JSON.parse(colegio);
            localStorage.removeItem("colegio");
            //this.evento.colegio=this.colegio.nombre;
            //console.log(this.colegio);
            
            //this.evento.colegio= this.colegios.filter((us) => us.nombre==this.colegio.nombre)[0];
            this.evento.rbd=this.colegio.rbd;
            //this.evento.propietario= this.usuarios.filter((us) => us.name==this.user.name)[0];
            //this.evento.propietario=this.colegio.propietario;
            this.evento.user_id=this.colegio.user_id;
            this.evento.sede_asociada=this.colegio.sede_asociada;
            this.evento.region=this.colegio.region;
            this.evento.comuna=this.colegio.comuna;
            this.evento.telefono=this.colegio.telefono;
            this.bloquearColegio=true
            axios.get('/api/get_usuarios').then(res=>{
                this.usuarios=res.data.usuarios;
                this.evento.propietario= this.usuarios.filter((us) => us.name==this.user.name)[0];
                this.evento.email= this.user.email;
                this.evento.telefono= this.user.telefono;
            });
            axios.get('/api/get_colegios').then(res=>{
                this.colegios=res.data.colegios;
                this.todos_colegios=res.data.colegios;
                this.evento.colegio= this.colegios.filter((us) => us.nombre==this.colegio.nombre)[0];
            });
        }else{
            //this.evento.colegio='SIN COLEGIO';
            this.evento.rbd='0000000';
            this.evento.user_id='';
            this.evento.sede_asociada='';
            this.evento.region='';
            this.evento.comuna='';
            this.evento.telefono='';
            //this.bloquearColegio=true
            axios.get('/api/get_usuarios').then(res=>{
                this.usuarios=res.data.usuarios;
                this.evento.propietario= this.usuarios.filter((us) => us.name==this.user.name)[0];
                this.evento.email= this.user.email;
                this.evento.telefono= this.user.telefono;
            });
            axios.get('/api/get_colegios').then(res=>{
                this.colegios=res.data.colegios;
                this.todos_colegios=res.data.colegios;
                this.evento.colegio= this.colegios.filter((us) => us.nombre=='SIN COLEGIO')[0];
            });
            //window.location.href = "/web/configuracion/colegios";
        }
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <loading-message v-if="isLoading" />
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mt-4">
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <div class="col-md-6"><label for="pais"> Nombre:</label></div>
                                    <div class="col-md-6 text-right"><label for="pais" class="text-primary"> * Campo Obligatorio</label></div>
                                    <div class="col-md-12"><input type="text" id="pais" v-model="evento.nombre_difusion" class="form-control border-primary"></div>
                                </div>
                                <!-- <div class="form-group row">
                                    <div class="col-md-6"><label for="pais"> Código:</label></div>
                                    <div class="col-md-6 text-right"><label for="pais" class="text-primary"> * Campo Obligatorio</label></div>
                                    <div class="col-md-12"><input type="text" id="name" v-model="evento.codigo" class="form-control border-primary"></div>
                                </div> -->
                                <!-- <div class="form-group row">
                                    <div class="col-md-6"><label for="pais"> Área:</label></div>
                                    <div class="col-md-6 text-right"><label for="pais" class="text-primary"> * Campo Obligatorio</label></div>
                                    <div class="col-md-12"><input type="text" id="name" v-model="evento.area" class="form-control border-primary"></div>
                                </div> -->
                                <div class="form-group row">
                                    <div class="col-md-6"><label for="pais"> Fecha y Hora inicio:</label></div>
                                    <div class="col-md-6 text-right"><label for="pais" class="text-primary"> * Campo Obligatorio</label></div>
                                    <div class="col-md-12"><input type="datetime-local" id="direccion" v-model="evento.fecha_inicio" class="form-control border-primary"></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6"><label for="pais"> Fecha y Hora de término:</label></div>
                                    <div class="col-md-6 text-right"><label for="pais" class="text-primary"> * Campo Obligatorio</label></div>
                                    <div class="col-md-12"><input type="datetime-local" id="ciudad" v-model="evento.fecha_termino" class="form-control border-primary"></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6"><label for="pais"> Tipo:</label></div>
                                    <div class="col-md-6 text-right"><label for="pais" class="text-primary"> * Campo Obligatorio</label></div>
                                    <div class="col-md-12">
                                        <multiselect v-model="evento.tipo"
                                            :options="tipos" 
                                            placeholder="Seleccionar tipo" 
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                            :custom-label="labelselect_tipo" 
                                            @select="ver_subtipo()">
                                            <template v-slot:noOptions><p>No hay opciones</p></template>
                                            <template v-slot:noResult>
                                                <p>No se encuentra coincidencia</p>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6"><label for="pais"> Subtipo:</label></div>
                                    <div class="col-md-6 text-right"><label for="pais" class="text-primary"> * Campo Obligatorio</label></div>
                                    <div class="col-md-12">
                                        <multiselect v-model="evento.subtipo"
                                            :options="subtiposfilter" 
                                            placeholder="Seleccionar subtipo" 
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                            :custom-label="labelselect_tipo" >
                                            <template v-slot:noOptions><p>No hay opciones</p></template>
                                            <template v-slot:noResult>
                                                <p>No se encuentra coincidencia</p>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="email"> Propietario:</label>
                                    <multiselect
                                        v-model="evento.propietario"
                                        :options="usuarios" 
                                        placeholder="Seleccionar usuario" 
                                        selectLabel="Presiona para seleccionar"
                                        selectedLabel="Seleccionado"
                                        deselectLabel="Presiona para remover"
                                        :custom-label="labelselect_usuarios"
                                        >
                                        <template v-slot:noOptions>
                                            <p>No hay opciones</p>
                                        </template>
                                        <template v-slot:noResult>
                                            <p>No se encuentra coincidencia</p>
                                        </template>
                                    </multiselect>
                                    <!-- <input type="email" id="email" v-model="evento.propietario" class="form-control border-primary"> -->
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <div class="col-md-6"><label for="pais"> Curso:</label></div>
                                    <div class="col-md-6 text-right"><label for="pais" class="text-primary"> * Campo Obligatorio</label></div>
                                    <div class="col-md-12">
                                        <multiselect v-model="evento.curso"
                                            :options="cursos" 
                                            :close-on-select="false"
                                            placeholder="Seleccionar curso" 
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                            :multiple="true">
                                            <template v-slot:noOptions><p>No hay opciones</p></template>
                                            <template v-slot:noResult>
                                                <p>No se encuentra coincidencia</p>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label for="pais"> Correo Notificaciones:</label>
                                    </div>
                                    <div class="col-md-6 text-right">
                                        <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                    </div>
                                    <div class="col-md-12">
                                        <input type="email" id="email" v-model="evento.email" class="form-control border-primary" @blur="validateEmail">
                                        <p v-if="emailError" class="error text-primary">{{ emailError }}</p>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label for="pais"> Teléfono Notificaciones:</label>
                                    </div>
                                    <div class="col-md-6 text-right">
                                        <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                    </div>
                                    <div class="col-md-12">
                                        <input type="email" id="email" v-model="evento.telefono" class="form-control border-primary" @input="formatPhoneNumber" @blur="validatePhoneNumber" @keydown="restrictToNumbers" maxlength="12">
                                        <p v-if="phoneerror" class="error text-primary">{{ phoneerror }}</p>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6"><label for="pais"> Nombre para Difusión Digital:</label></div>
                                    <div class="col-md-6 text-right"><label for="pais" class="text-primary"> * Campo Obligatorio</label></div>
                                    <div class="col-md-12"><input type="email" id="email" v-model="evento.titulo_landing_inscripcion" class="form-control border-primary"></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6"><label for="pais"> Coordinador Evento:</label></div>
                                    <div class="col-md-6 text-right"><label for="pais" class="text-primary"> * Campo Obligatorio</label></div>
                                    <div class="col-md-12">
                                        <multiselect 
                                            v-model="evento.coordinador_evento"
                                            :options="usuarios" 
                                            placeholder="Seleccionar usuario" 
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                            :custom-label="labelselect_usuarios">
                                            <template v-slot:noOptions><p>No hay opciones</p></template>
                                            <template v-slot:noResult>
                                                <p>No se encuentra coincidencia</p>
                                            </template>
                                        </multiselect>
                                        <!-- <input type="email" id="email" v-model="evento.coordinador_evento" class="form-control border-primary"> -->
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6"><label for="pais"> Colegio:</label></div>
                                    <div class="d-flex col-md-6">
                                        <b-form-radio class="pr-2" v-model="selected" name="some-radios" value="Todos" @change="cambio_colegios">Todos</b-form-radio>
                                        <b-form-radio class="pr-2" v-model="selected" name="some-radios" value="Mis colegios" @change="cambio_colegios">Mis colegios</b-form-radio>
                                    </div>
                                    <div class="col-md-12">
                                        <multiselect 
                                            v-model="evento.colegio"
                                            :options="colegios" 
                                            placeholder="Seleccionar colegio" 
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                            :custom-label="labelselect_colegio"
                                            :disabled="bloquearColegio">
                                            <template v-slot:noOptions><p>No hay opciones</p></template>
                                            <template v-slot:noResult>
                                                <p>No se encuentra coincidencia</p>
                                            </template>
                                        </multiselect>
                                    </div>
                                    <!-- <div class="col-md-12" v-if="evento.colegio && evento.colegio.rbd!='0000000'">
                                        <label for="">Correo orientador:</label>
                                        <input type="text" id="colegio" v-model="evento.colegio.correo_colegio_2" :class="(evento.colegio.correo_colegio_2==null || evento.colegio.correo_colegio_2=='')?'form-control border-danger':'form-control border-primary'">
                                    </div> -->
                                </div>
                            </div>
                            <div class="offset-lg-3 col-lg-6">
                                <b-button block variant="primary" @click="validacion">Agregar</b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>